// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vuetify/dist/vuetify.min.css
// module id = 671
// module chunks = 29